import React from "react";

type FoundryButtonVariant = "primary" | "secondary" | "danger" | "ghost";

type FoundryButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: FoundryButtonVariant;
};

const variantClasses: Record<FoundryButtonVariant, string> = {
  primary:
    "bg-orange-500 text-white hover:bg-orange-400 border-orange-500",
  secondary:
    "bg-white text-slate-700 hover:bg-slate-50 border-slate-200 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-white/10 dark:border-white/10",
  danger:
    "bg-white text-red-600 hover:bg-red-50 border-red-200 dark:bg-slate-950 dark:text-red-300 dark:hover:bg-red-500/10 dark:border-red-500/30",
  ghost:
    "bg-transparent text-slate-600 hover:bg-slate-100 border-transparent dark:text-slate-300 dark:hover:bg-white/10",
};

const FoundryButton: React.FC<FoundryButtonProps> = ({
  variant = "secondary",
  className = "",
  children,
  ...props
}) => {
  return (
    <button
      {...props}
      className={[
        "rounded-lg border px-4 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50",
        variantClasses[variant],
        className,
      ].join(" ")}
    >
      {children}
    </button>
  );
};

export default FoundryButton;
